// extracted by mini-css-extract-plugin
export default {"triggerButton":"infoicon_triggerButton__jwCwb","iconImage":"infoicon_iconImage__tsSja","tooltip":"infoicon_tooltip__qWcJ3","fadeIn":"infoicon_fadeIn__Nf6qA"};